import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';
import CategoryDropdown from '@/components/feature/CategoryDropdown';

export default function CategorySection() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="bg-white">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-16 md:py-20">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-stone-900">{t('home.catTitle')}</h2>
          <p className="mt-4 text-sm md:text-base text-stone-600">{t('home.catSubtitle')}</p>
        </div>

        <div className="mt-8 flex justify-center">
          <CategoryDropdown />
        </div>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((c) => (
            <a
              key={c.id}
              href={c.link}
              target="_blank"
              rel="noopener nofollow"
              className="group rounded-lg border border-stone-200 bg-white overflow-hidden hover:border-emerald-300 transition-colors cursor-pointer"
            >
              <div className="w-full h-36 md:h-44 overflow-hidden">
                <img
                  src={c.image}
                  alt={t(c.nameKey)}
                  title={`${t(c.nameKey)} USFans Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-3 flex items-center justify-between">
                <span className="text-sm font-medium text-stone-800 whitespace-nowrap truncate">{t(c.nameKey)}</span>
                <span className="w-6 h-6 rounded-full bg-emerald-50 text-emerald-600 flex items-center justify-center shrink-0">
                  <i className="ri-arrow-right-up-line text-sm" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}